import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { useAuth } from "../helpers/auth";
import { ToastContainer } from 'react-toastify'
import { successAlert } from '../utils/toastifyAlerts'
import '../styles/MainNavbar.css';

const MainNavbar = () => {

  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    successAlert('logout successful')
  };

  return (
    <Navbar className='customNavbar' bg="light" expand="xs">
      <Container>
        <Navbar.Toggle aria-controls="" />
        <Navbar.Collapse id="">
          <Nav className="me-auto">
            <Nav.Link href="/home">home</Nav.Link>
            <Nav.Link href="/resumeCreator">resume creator</Nav.Link>
            <Nav.Link href="/profile">profile</Nav.Link>
            <Nav.Link href="/OpeningManager">Opening Manager</Nav.Link>
            <button className='btnSCV-b' onClick={handleLogout}>logout</button>
          </Nav>
        </Navbar.Collapse>
      </Container>
      <ToastContainer />
    </Navbar>
  )
}

export default MainNavbar;

